import { render, staticRenderFns } from "./userSetting.vue?vue&type=template&id=91a292e2&scoped=true"
import script from "./userSetting.vue?vue&type=script&lang=js"
export * from "./userSetting.vue?vue&type=script&lang=js"
import style0 from "./userSetting.vue?vue&type=style&index=0&id=91a292e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a292e2",
  null
  
)

export default component.exports